/**
 * Money formatting helpers. All amounts are integer cents.
 *
 * `dollars` is the canonical two-decimal renderer ("$12.34"); null/undefined
 * render as an em dash so callers can pass optional API fields directly.
 * `wholeDollars` is the marketing-card variant — rounded to whole dollars
 * with thousands separators ("$1,235") — kept separate on purpose; do not
 * "unify" them, the outputs are intentionally different.
 */
export function dollars(cents: number | null | undefined): string {
    return cents == null ? '—' : `$${(cents / 100).toFixed(2)}`;
}

export function wholeDollars(cents: number): string {
    return `$${(cents / 100).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})}`;
}
